module.exports = __webpack_public_path__ + "static/media/UAB.1553b4ea.png";